import { render, staticRenderFns } from "./dbuydet.vue?vue&type=template&id=47d9f293&scoped=true&"
import script from "./dbuydet.vue?vue&type=script&lang=js&"
export * from "./dbuydet.vue?vue&type=script&lang=js&"
import style0 from "./dbuydet.vue?vue&type=style&index=0&id=47d9f293&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d9f293",
  null
  
)

export default component.exports